import { extend } from 'vee-validate'
import { min } from 'vee-validate/dist/rules'

// Min rule
extend('min', {
  ...min,
  message: 'Pole musi składać się przynajmniej z {length} znaków'
})
